import React from 'react';
import { useAuth } from '../../contexts/AuthContext.helpers';
import AccessDenied from '../../components/auth/AccessDenied';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
const SelfServicePage = React.lazy(() => import('./SelfServicePage'));

export default function SelfServiceRoute() {
  const { t } = useTranslation();
  const auth = useAuth() as any;
  const { user, isLoading } = auth;
  const [searchParams] = useSearchParams();

  if (isLoading) return null;

  const permissions: string[] = (user as any)?.permissions || [];
  const allowed = permissions.includes('selfservice') || 
                  permissions.includes('self_service_fba') || 
                  permissions.includes('fba') || 
                  permissions.includes('admin');

  if (!allowed) {
    return <AccessDenied />;
  }

  // Get section from URL parameters
  const section = searchParams.get('section') || 'dashboard';

  return (
    <React.Suspense fallback={<div />}>
      <SelfServicePage initialSection={section} />
    </React.Suspense>
  );
}
